export default {
  showFeatures : (application) => application.feature,
  /** @deprecated */
  isDark       : (application) => {
    if (application.isMobile) {
      return application.mobileThemeIsDark;
    }

    return application.webThemeIsDark;
  },
  hasEmailLogin : (application) => application.authenticationsModes.hasAuthByEmail,
  hasAuthBySaml : (application) => application.authenticationsModes.hasAuthBySaml,
  samlProvider  : (application) => {
    return {
      url  : application.authenticationsModes.samlRequest?.url,
      type : application.authenticationsModes.samlRequest?.providerType,
      name : application.authenticationsModes.samlRequest?.providerName,
      logo : application.authenticationsModes.samlRequest?.providerLogo
    };
  },
  isOperation          : (application) => application.isOperation,
  createAccountEnabled : (application) => application.createAccountEnabled,
  actionList           : (state, getters, rootState, rootGetters) => {
    return [
      {
        icon       : 'mdi-account-circle-outline',
        i18nKey    : '_core.myAccount.title',
        dataTestId : 'profile-menu-my-account',
        isVisible  : true,
        isDisabled : false,
        onclick    : async ({ $router }) => {
          $router.push('/my-account');
        }
      },
      {
        icon       : 'mdi-card-account-details-outline',
        i18nKey    : 'studentCard',
        hasDivider : true,
        isVisible  : rootState._core.auth.currentRole.role.alias === 'student' && rootGetters['plataforma/institutionConfiguration/showStudentCard'],
        isDisabled : false,
        onclick    : async ({ $router }) => {
          $router.push('/wc/academic-services/enrollment-student-card');
        }
      },
      {
        icon       : 'mdi-exit-to-app',
        i18nKey    : '_core.userMenu.logout',
        dataTestId : 'profile-menu-logout',
        isVisible  : true,
        isDisabled : rootGetters['_core/auth/isImpersonated'],
        onclick    : async ({ $store, $loading }) => {
          $loading.start();
          await $store.dispatch('_core/auth/actionSignOut');
          $loading.finish();
        }
      }
    ];
  }
};
